import styles from "./Footer.module.scss";
import classNames from "classnames/bind";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faFacebookSquare } from "@fortawesome/free-brands-svg-icons";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
const cx = classNames.bind(styles);
function Footer() {
    console.log("Sidebar");
    const mediaQuery = window.matchMedia("(min-width: 768px)").matches;
    // const h5 = document.getElementsByClassName(cx("care"));
    const handleClick = (e) => {
        if (!mediaQuery) {
            e.target.classList.toggle(cx("mshow"));
        }
    };
    return (
        <div className={cx("wrapper")}>
            <div className={cx("inner")}>
                <div className={cx("info")}>
                    <div>
                        <span>
                            <Link to={"/"}>
                                {" "}
                                <img
                                    src="https://i.ibb.co/2vrRgnc/200.webp"
                                    alt="logo Vũ trụ siêu xe - Supercar Universe"
                                />
                            </Link>

                            <h5>Vũ Trụ Siêu Xe - Supercar Universe</h5>
                        </span>
                        <p>
                            Vũ Trụ Siêu Xe - Supercar Universe là trang web tổng
                            hợp thông tin, tin tức, đánh giá, thông số của tất
                            cả các dòng siêu xe của các hãng xe nổi tiếng trên
                            thế giới.
                        </p>
                        <p>
                            Điện thoại:{" "}
                            <a href="tel:0378859736">0378 859 736</a>
                        </p>
                        <p>
                            Email:{" "}
                            <a href="mailto:universe.supercar@gmail.com">
                                universe.supercar@gmail.com
                            </a>
                        </p>
                        <p>
                            <a
                                target="_blank"
                                rel="noreferrer"
                                href="https://goo.gl/maps/rsUyx3MkqoQvpJCBA"
                            >
                                Địa chỉ: 56 Hoàng Diệu 2, Linh Chiểu, TP. Thủ
                                Đức, TP. Hồ Chí Minh
                            </a>
                        </p>
                    </div>
                    <div>
                        <h5
                            className={cx("care", "mshow")}
                            onClick={handleClick}
                        >
                            <span> Hãng xe được quan tâm</span>
                            {!mediaQuery && (
                                <i>
                                    <FontAwesomeIcon icon={faAngleDown} />
                                </i>
                            )}
                        </h5>
                        <div>
                            <Link to={"/brands/lamborghini"}>
                                <p>Lamborghini</p>
                            </Link>
                            <Link to={"/brands/bugatti"}>
                                <p>Bugatti</p>
                            </Link>
                            <Link to={"/brands/ferrari"}>
                                <p>Ferrari</p>
                            </Link>
                            <Link to={"/brands/pagani"}>
                                <p>Pagani</p>
                            </Link>
                            <Link to={"/brands/aston-martin"}>
                                <p>Aston Martin</p>
                            </Link>
                        </div>
                    </div>
                    <div>
                        <h5
                            className={cx("care", "mshow")}
                            onClick={handleClick}
                        >
                            <span>Dòng xe được quan tâm</span>
                            {!mediaQuery && (
                                <i>
                                    <FontAwesomeIcon icon={faAngleDown} />
                                </i>
                            )}
                        </h5>
                        <div>
                            <Link to={"/brands/lamborghini/huracan-evo"}>
                                <p>Huracan Evo</p>
                            </Link>
                            <Link to={"/brands/bugatti/chiron"}>
                                <p>Chiron Super Sport</p>
                            </Link>
                            <Link to={"/brands/bugatti/la-voiture-noire"}>
                                <p>La Voiture Noire</p>
                            </Link>
                            <Link to={"/brands/lamborghini/urus"}>
                                <p>Lamborghini Urus</p>
                            </Link>
                            <Link to={"/brands/aston-martin/db11"}>
                                <p>DB 11</p>
                            </Link>
                        </div>
                    </div>
                    <div>
                        <h5>Hỗ trợ</h5>
                        <Link to={" "}>
                            <p>Giới thiệu</p>
                        </Link>
                        <Link to={" "}>
                            <p>Bảo mật</p>
                        </Link>
                        <Link to={" "}>
                            <p>Điều khoản</p>
                        </Link>
                        <Link to={" "}>
                            <p>Báo lỗi</p>
                        </Link>
                    </div>
                </div>
                <div className={cx("copy")}>
                    <span>
                        © 2022 Supercar Universe - Cập nhật thông tin siêu xe
                        của các hãng nổi tiếng trên thế giới | Dev-Owner by{" "}
                        <a
                            className={cx("trongphuc")}
                            href="https://www.facebook.com/turni0/"
                            target="_blank"
                            rel="noreferrer"
                        >
                            Trọng Phúc
                        </a>
                    </span>
                    <span>
                        <a
                            href={`https://www.dmca.com/Protection/Status.aspx?ID=5b54a35f-0d9c-4ab4-8710-e0320a1eeadc&refurl=https://supercaruniverse.netlify.app/`}
                            target="_blank"
                            rel="noreferrer"
                        >
                            <img
                                src="https://images.dmca.com/Badges/dmca-badge-w150-5x1-08.png?ID=5b54a35f-0d9c-4ab4-8710-e0320a1eeadc"
                                alt="DMCA.com Protection Status"
                            />
                        </a>
                        <a
                            href="https://www.facebook.com/turni0"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <FontAwesomeIcon icon={faFacebookSquare} />
                        </a>
                    </span>
                </div>
            </div>
        </div>
    );
}

export default Footer;
